import momentJ from 'moment-jalaali';
import moment from 'moment';

export const persianToGregorian = (input: string, format: string, locale: string): string => {
    if (!input) {
        return '';
    }
    if (locale === 'fa') {
        momentJ.loadPersian({
            usePersianDigits: true,
            dialect: 'persian-modern',
        });
    } else {
        moment.locale('en');
    }
    return momentJ(input, 'jYYYY/jMM/jDD').format(format);
};

export const persianDateTimeToGregorian = (
    input: string,
    format: string,
    locale: string,
): string => {
    if (!input) {
        return '';
    }
    if (locale === 'fa') {
        momentJ.loadPersian({
            usePersianDigits: true,
            dialect: 'persian-modern',
        });
    } else {
        moment.locale('en');
    }
    return momentJ(input, 'jYYYY/jMM/jDD H:mm:ss').format(format);
};

export const getDifferenceDateTime = (input: string, inputFormat = 'jYYYY/jMM/jDD H:mm:ss', outputFormat = 'YYYY-MM-DD H:mm:ss') => {
    // .format('YYYY-MM-DD h:mm:ss')
    const jInput = momentJ(input, inputFormat).format(outputFormat);
    const currentDate = moment().format('YYYY-MM-DD H:mm:ss');

    // const differenceInDays = currentDate.diff(moment(jInput), 'days');
    const differenceInDays = moment(jInput).diff(moment(currentDate), 'days');
    const differenceInHours = moment(jInput).diff(moment(currentDate), 'hours');
    const differenceInMinutes = moment(jInput).subtract('hours', differenceInHours).diff(moment(currentDate), 'minutes');
    const differenceInSeconds = moment(jInput).subtract('hours', differenceInHours).subtract('minutes', differenceInMinutes).diff(moment(currentDate), 'seconds');

    return `${differenceInDays}:${differenceInHours}:${differenceInMinutes}:${differenceInSeconds}`
}

export const isWarningDateAfterCurrentDate = (input: string, inputFormat = 'jYYYY/jMM/jDD H:mm:ss', outputFormat = 'YYYY-MM-DD H:mm:ss') => {
    const jInput = momentJ(input, inputFormat).format(outputFormat);
    const currentDate = moment(moment().format('YYYY-MM-DD H:mm:ss'));
    return moment(currentDate).isAfter(jInput)
}